import * as yup from 'yup'

export const AUTO_ENROLL_MODES = {
  NONE: 'none',
  ALL: 'all',
  BY_PROFILE: 'by_profile',
}

export const schema = yup.object().shape({
  showAnswerKey: yup.boolean().required(),
  autoEnrollMode: yup.string().required(),
  autoEnrollProfileIds: yup.array().when('autoEnrollMode', {
    is: AUTO_ENROLL_MODES.BY_PROFILE,
    then: (schemaItem) => schemaItem.min(1).required(),
  }),
  notifyOnCompleteEnabled: yup.boolean(),
  notifyOnCompleteDate: yup.string().when('notifyOnCompleteEnabled', {
    is: true,
    then: (schemaItem) => schemaItem.required('A data é obrigatória'),
  }),
})

export default schema
